
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/campaign-intelligence/overview",
      function () {
        return require("private-next-pages/campaign-intelligence/overview.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/campaign-intelligence/overview"])
      });
    }
  